







































































































import { snakeCase } from 'lodash'
import { Component, Emit, Mixins, Prop, VModel } from 'vue-property-decorator'

import { BotProperty } from '../../../../../../../../../../BotProperties/components/Properties/types'
import { getNewPropertyIcon } from '../../../../../../../../../../BotProperties/utils'
import { UseFields } from '../../../../../../../../../../Pi'
import { FieldData } from '../../../../../../../../../../Pi/types'
import findPropertyById from '../../../../../../../../logic/Helpers/findPropertyById'
import BaseCondition from '../../../../logic/ConditionTypes/BaseCondition'
import BetweenCondition from '../../../../logic/ConditionTypes/BetweenPropertyCondition'
import BetweenPropertyCondition from '../../../../logic/ConditionTypes/BetweenPropertyCondition'
import LabelCondition from '../../../../logic/ConditionTypes/LabelConditions/LabelCondition'
import PropertyCondition from '../../../../logic/ConditionTypes/PropertyCondition'
import SetPropertyCondition from '../../../../logic/ConditionTypes/SetPropertyConditions/SetPropertyCondition'
import { ConditionOptions, ConditionsNodeProps } from '../../../../logic/types'
import { SelectedPropertyType } from '../types'
import LabelConditionParams from './LabelConditionParams.vue'
import PropertyConditionParams from './PropertyConditionParams.vue'
import ConditionSettings from './components/ConditionSettings.vue'

@Component({
  components: {
    LabelConditionParams,
    PropertyConditionParams,
    ConditionSettings,
  },
  data() {
    return {
      SelectedPropertyType,
      LabelCondition,
      PropertyCondition,
      BetweenCondition,
      getNewPropertyIcon,
      SetPropertyCondition,
      snakeCase,
      BetweenPropertyCondition,
    }
  }
})
export default class ConditionParamCell extends Mixins(UseFields) {
  @VModel() condition!: BaseCondition

  @Prop() properties!: Array<BotProperty>

  @Prop() prevConditionType!: SelectedPropertyType | null

  @Prop() selectedPropertyId!: number | null

  @Prop() createProperty!: ConditionsNodeProps['createNewProperty']

  @Prop() createLabel!: ConditionsNodeProps['createNewLabel']

  @Emit()
  setConditionToNode(): this {
    return this
  }

  @Emit()
  addCondition(): this {
    return this
  }

  get selectedProperty(): BotProperty | undefined {
    if (this.selectedPropertyId) {
      return findPropertyById(this.properties, this.selectedPropertyId)
    }

    return undefined
  }

  get ignoreCase() {
    if (this.condition instanceof BetweenPropertyCondition || this.condition instanceof PropertyCondition) {
      return this.condition?.options?.includes(ConditionOptions.IgnoreCase)
    }

    return false
  }

  set ignoreCase(state: boolean) {
    if (this.selectedProperty && (this.condition instanceof BetweenPropertyCondition || this.condition instanceof PropertyCondition)) {
        if (!state) {
          this.condition.options = this.condition.options.filter(o => o !== ConditionOptions.IgnoreCase)
        } else {
          this.condition.options.push(ConditionOptions.IgnoreCase)
        }
    }
  }

  modelSetter(arg: FieldData): FieldData {
    arg.setter = (val) => arg.model[arg.key] = val
    return arg
  }
}
